import { errorMsg } from '../constants/messages';

const homepageServiceCategoriesFormData = [
  {
    title: 'Homepage Service Category',
    name: 'name',
    label: 'Category Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Category Name',
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'sortOrder',
    label: 'Sort Order',
    fieldType: {
      name: 'number',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Sort Order',
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
  },
];

export { homepageServiceCategoriesFormData };
